module.exports = __webpack_public_path__ + "static/media/4.f6fa4c37.mp3";